<template>
	<div class="comp">
		<el-dialog :title="title" :visible.sync="dialogState" width="500px" :close-on-click-modal="false">
			<el-form :inline="true" style="padding-top:20px;">
				<el-form-item label="经办人：" :label-width="formLabelWidth">
					<el-select style="width:250px" v-model="curStaff" multiple filterable placeholder="请选择经办人">
						<el-option v-for="item in staffList" :key="item._id" :label="item.basic_info.nick_name"
						:value="item._id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="备注：" :label-width="formLabelWidth">
					<el-input style="width:250px" type="textarea" v-model="remark" :rows="4" placeholder="请输入备注" clearable></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				dialogState:true,
				title:'',
				formLabelWidth: '100px',
				remark:'',
				curStaff:[],
				staffList:[],
			}
		},
		props:{
			id:{
				default:''
			},
			type:{
				default:''
			}
		},
		watch:{
			dialogState(n){
				if(n==false){
					this.$emit('submit',"close")
				}
			}
		},
		mounted() {
			this.$util.getStaffList().then(list=>{
				this.staffList = list;
			})
		},
		methods: {
			cancel(){
				this.$emit("submit","cancel")
			},
			submit(){
				if(this.curStaff.length===0){
					this.$message({
						message: '请选择经办人',
						type: 'error'
					});
					return ;
				}
				let salesMans = [];
				for(let i=0;i<this.curStaff.length;i++){
					salesMans.push({
						userId:this.curStaff[i],
						userName:this.$public.getMatchingItem(this.staffList,'_id',this.curStaff[i]).basic_info.nick_name,
					})
				}
				if(this.type==='ymqc'){
					let params = {
						planId:this.id,
						remark:this.remark,
						salesMans:salesMans
					}
					let loading = this.$loading();
					this.$http.post('/api/MedicalPackage/Plan/Complete', params).then(res => {
						loading.close();
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.$emit("submit","success")
						}
					})
				}else if(this.type==='ylfw'){
					let params = {
						serviceId:this.id,
						remark:this.remark,
						salesMans:salesMans
					}
					let loading = this.$loading();
					this.$http.post('/api/MedicalService/Comlete', params).then(res => {
						loading.close();
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.$emit("submit","success")
						}
					})
				}
			},
		}
	}
</script>
<style lang="scss" scoped>
	.comp {
		
	}
</style>
